"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.IntroTextStyled = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Inner = exports.Inner = (0, _mui.styled)('div')(()=>({
        display: 'flex',
        flexDirection: 'column'
    }));
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(8)
        }
    };
});
const IntroTextStyled = exports.IntroTextStyled = (0, _mui.styled)(_presentationComponents.IntroText)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            margin: 'auto'
        }
    };
});
